// ============================================
// Cheat Console (Patreon only)
// Extracted from main.js
// ============================================

import { variableManager } from '../engine/variables.js';
import { L } from '../systems/localization.js';
import { isPat } from '../engine/pgate.js';

import { layoutManager } from './layout.js';
import { phoneUI } from './phone.js';

export const cheatConsoleUI = {
    /**
     * Adds the cheat button to the pause menu footer (Patreon only).
     */
    init() {
        if (!isPat()) return;

        // Wire variable manager into phone for cheat access
        if (typeof phoneUI !== 'undefined' && phoneUI?.setVariableManager && typeof variableManager !== 'undefined') {
            phoneUI.setVariableManager(variableManager);
        }

        // Add cheat button to pause menu — opens phone cheat app directly
        const footer = document.querySelector('.pause-footer');
        if (!footer) return;
        const btn = document.createElement('button');
        btn.className = 'btn-pause-secondary';
        btn.textContent = L.get('ui.cheat_console');
        btn.style.color = '#ff6b9d';
        btn.addEventListener('click', () => {
            layoutManager.closeOverlay('overlay-pause');
            if (typeof phoneUI !== 'undefined' && phoneUI?.openCheats) {
                phoneUI.openCheats();
            } else {
                cheatConsoleUI.open(); // Fallback to standalone overlay
            }
        });
        footer.insertBefore(btn, footer.firstChild);
    },

    /**
     * Opens the standalone cheat console overlay (fallback when phone cheat app unavailable).
     */
    open() {
        let overlay = document.getElementById('overlay-cheat');
        if (!overlay) {
            overlay = document.createElement('div');
            overlay.id = 'overlay-cheat';
            overlay.className = 'overlay-fullscreen hidden';
            overlay.innerHTML = `
                <div class="overlay-box cheat-console-box">
                    <h3>${L.get('ui.cheat_console')}</h3>
                    <div class="cheat-row"><label>Money</label><input type="number" id="cheat-money" value="0" step="100"><button id="cheat-money-btn">Set</button></div>
                    <div class="cheat-row"><label>Femininity</label><input type="number" id="cheat-fem" value="0" min="0" max="200"><button id="cheat-fem-btn">Set</button></div>
                    <div class="cheat-row"><label>Submissiveness</label><input type="number" id="cheat-sub" value="0" min="0" max="100"><button id="cheat-sub-btn">Set</button></div>
                    <div class="cheat-row"><label>Arousal</label><input type="number" id="cheat-arousal" value="0" min="0" max="100"><button id="cheat-arousal-btn">Set</button></div>
                    <div class="cheat-row"><label>Energy</label><input type="number" id="cheat-energy" value="100" min="0" max="120"><button id="cheat-energy-btn">Set</button></div>
                    <div class="cheat-row"><label>Day</label><input type="number" id="cheat-day" value="1" min="1"><button id="cheat-day-btn">Set</button></div>
                    <div class="cheat-row"><label>TimeSlot</label><input type="number" id="cheat-time" value="0" min="0" max="3"><button id="cheat-time-btn">Set</button></div>
                    <div class="cheat-row" style="justify-content:center;margin-top:12px;"><button id="cheat-close" style="width:100%">Close</button></div>
                </div>`;
            document.body.appendChild(overlay);

            // Wire up buttons
            const setVar = (inputId, varName) => {
                document.getElementById(inputId)?.addEventListener('click', () => {
                    const val = parseInt(document.getElementById(inputId.replace('-btn', '')).value);
                    if (!isNaN(val) && variableManager) {
                        variableManager.setValue(varName, val);
                    }
                });
            };
            setVar('cheat-money-btn', 'Money');
            setVar('cheat-fem-btn', 'Femininity');
            setVar('cheat-sub-btn', 'Submissiveness');
            setVar('cheat-arousal-btn', 'Arousal');
            setVar('cheat-energy-btn', 'Energy');
            setVar('cheat-day-btn', 'Day');
            setVar('cheat-time-btn', 'TimeSlot');

            document.getElementById('cheat-close')?.addEventListener('click', () => {
                layoutManager.closeOverlay('overlay-cheat');
            });
            overlay.addEventListener('click', (e) => {
                if (e.target === overlay) layoutManager.closeOverlay('overlay-cheat');
            });
        }

        // Pre-fill current values
        if (variableManager) {
            const get = (n) => variableManager.getValue?.(n) ?? variableManager.baseVar?.[n] ?? 0;
            document.getElementById('cheat-money').value = get('Money');
            document.getElementById('cheat-fem').value = get('Femininity');
            document.getElementById('cheat-sub').value = get('Submissiveness');
            document.getElementById('cheat-arousal').value = get('Arousal');
            document.getElementById('cheat-energy').value = get('Energy');
            document.getElementById('cheat-day').value = get('Day');
            document.getElementById('cheat-time').value = get('TimeSlot');
        }

        layoutManager.openOverlay('overlay-cheat');
    },
};
